import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AllScanTunnelQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AllScanTunnelQuery = { __typename?: 'Query', scanTunnels: Array<{ __typename?: 'ScanTunnel', id: string, name: string, mode: Types.ScanTunnelMode }> };


export const AllScanTunnelDocument = gql`
    query allScanTunnel {
  scanTunnels {
    id
    name
    mode
  }
}
    `;

/**
 * __useAllScanTunnelQuery__
 *
 * To run a query within a React component, call `useAllScanTunnelQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllScanTunnelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllScanTunnelQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllScanTunnelQuery(baseOptions?: Apollo.QueryHookOptions<AllScanTunnelQuery, AllScanTunnelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllScanTunnelQuery, AllScanTunnelQueryVariables>(AllScanTunnelDocument, options);
      }
export function useAllScanTunnelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllScanTunnelQuery, AllScanTunnelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllScanTunnelQuery, AllScanTunnelQueryVariables>(AllScanTunnelDocument, options);
        }
export type AllScanTunnelQueryHookResult = ReturnType<typeof useAllScanTunnelQuery>;
export type AllScanTunnelLazyQueryHookResult = ReturnType<typeof useAllScanTunnelLazyQuery>;
export type AllScanTunnelQueryResult = Apollo.QueryResult<AllScanTunnelQuery, AllScanTunnelQueryVariables>;